import { Component, ViewChild } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { IXSModalComponent } from "../../../../../components/ixsmodal/ixsmodal.component";
import { GenEnum } from "../../../../shared/general.enum";

@Component({
    selector: 'child-cell',
    template: ` <img  style="width: 27px;
    height: 27px;
    padding: 0px !important;" src={{imageSource}} alt="Image"onerror="this.src='assets/AdminLTE_New/images/blank.png'">`,
    styleUrls: ['studentattendance.component.scss']
})
export class ChildMessageRenderer implements ICellRendererAngularComp {
    public params: any;
    imageurl: string;
    imageSource: any;
    private visible= false;

    @ViewChild('modalPicture') public modalPicture: IXSModalComponent;
    agInit(params: any): void {
        this.params = params;
        this.imageSource = localStorage.getItem('OnlyUrl') + GenEnum.Image.imageUrl + this.params.value;
    }

    public async invokeParentMethod() {


        this.imageSource = localStorage.getItem('OnlyUrl') + GenEnum.Image.imageUrl + this.params.value;

    }

    refresh(): boolean {
        return false;
    }

    

    
}


// WEBPACK FOOTER //
// ./src/app/shell/forms/school-management/student-attendance/studentattendance/studentimage.component.ts